import * as Actions from '../actions'
import { LoftServices } from '../../../types/loft'

Actions.withOperationName(Actions)

export default [
  Actions.safeSetMessageIds,
  Actions.awaitAsync('teamEmailSettings', ({ gateway }: LoftServices) =>
    gateway.teamEmailSettings.show()
  ),
  Actions.setRestMessage,
  Actions.awaitAsync('body', ({ office }: LoftServices) => office.item.getBody()),
  Actions.awaitAsync('attachments', ({ office }: LoftServices) => office.item.getAttachments()),
  Actions.updateProgress('connecting_server'),
  Actions.ewsGetMessage,
  Actions.updateProgress('connecting_salesloft'),
  Actions.addDraftMailingIdToState,
  Actions.melodyLoft,
  Actions.addDraftMailingIdToCustomProperties,
  Actions.updateProgress('sending'),
  Actions.updateParentEmail,
  Actions.sendEmail,
  Actions.stopProgress,
  Actions.melodyMarkLofted,
  Actions.loftSuccess,
  Actions.itemClose,
]
